import React, { PropsWithChildren } from "react";
//#region types
import { DescriptionProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const Description: React.FC<PropsWithChildren<DescriptionProps>> = ({ children, horizontal, className }) => {
  return (
    <Grid
      item
      className={clsx(
        cssExports.formControlDescription,
        horizontal ? "" : cssExports.verticalFormDescription,
        className
      )}
    >
      {children}
    </Grid>
  );
};

export default Description;
